  import React, { useEffect, useState, useRef } from "react";
  import { db, auth, storage } from "../firebase";
  import {
    doc, getDoc,
    collection, addDoc,
    query, where, getDocs,
    deleteDoc,
    updateDoc
  } from "firebase/firestore";
  import { useParams, useNavigate } from "react-router-dom";
  import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

  function Space() {
    const { spacelink } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      setUser(u);
    });

    return () => unsub();
  }, []);
    const [status, setStatus] = useState("loading");
    const [space, setSpace] = useState(null);
    
    const [entered, setEntered] = useState(false);

    const isOwner = user && space?.ownerUid === user.uid;

    const playerRef = useRef(null);
    const pageRef = useRef(null);
    const [playing, setPlaying] = useState(false);

    const [posts, setPosts] = useState([]);
    const [uploadingBg, setUploadingBg] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const [coverImages, setCoverImages] = useState(space?.coverImages || []);
    const [coverIndex, setCoverIndex] = useState(0);
    const [imagesReady, setImagesReady] = useState(false);
    const [prevCover, setPrevCover] = useState(null);
    const [fade, setFade] = useState(false);
    const [selectedRsvp, setSelectedRsvp] = useState(null);
    const [isEditingRsvp, setIsEditingRsvp] = useState(false);
    const [selectedCountdown, setSelectedCountdown] = useState(false);
    const [countdownDate, setCountdownDate] = useState("");
    const [showCountdownModal, setShowCountdownModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [countdownTitle, setCountdownTitle] = useState("");
    const [coverReady, setCoverReady] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const DEFAULT_TAB_ID = "Space";
    const [activeTab, setActiveTab] = useState(DEFAULT_TAB_ID);

useEffect(() => {
  if (pageRef.current) {
    pageRef.current.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }
}, [activeTab]);

const [guestNames, setGuestNames] = useState([""]);
const [declineMessage, setDeclineMessage] = useState("");

const [rsvpAnswer, setRsvpAnswer] = useState(null);
const [guestMessage, setGuestMessage] = useState("");

const [rsvpTitle, setRsvpTitle] = useState("");
const [rsvpDescription, setRsvpDescription] = useState("");

const [submitted, setSubmitted] = useState(false);
const [error, setError] = useState("");

const resetRSVP = () => {
  setSelectedRsvp(null);
  setIsEditingRsvp(false);
  setGuestNames([""]);
  setRsvpAnswer(null);
  setGuestMessage("");
  setError("");
  setDeclineMessage(""); // IMPORTANT (you already have this state)
};

const closeRSVP = () => {
  setSelectedRsvp(null);
  setIsEditingRsvp(false);
  setGuestNames([""]);
  setRsvpAnswer(null);
  setGuestMessage("");
  setError("");
};

  const [tabs, setTabs] = useState([
  { id: "Space", label: "Space" },
  { id: "media", label: "Media" },
  { id: "about", label: "About" },
]);

const isMounted = useRef(true);

useEffect(() => {
  return () => {
    isMounted.current = false;
  };
}, []);

const addTab = async () => {
  // 🔒 block non-owner immediately
  if (!isOwner) return;

  // 🔒 enforce max 5 tabs
  if (tabs.length >= 5) return;

  const newTab = {
    id: `tab_${Date.now()}`,
    label: "New Tab",
  };

const fixedTabs = tabs.filter(
  (t) => t.id !== "media" && t.id !== "about"
);

const updated = [
  ...fixedTabs,
  newTab,
  ...tabs.filter((t) => t.id === "media" || t.id === "about")
];

  setTabs(updated);
  setActiveTab(newTab.id);

  try {
if (!space?.id) return;

await updateDoc(doc(db, "spaces", space.id), {
  tabs: updated,
});
  } catch (err) {
    console.error("Failed to add tab:", err);
  }
};

const [editingTab, setEditingTab] = useState(null);
const [editValue, setEditValue] = useState("");

const startEditTab = (tab) => {
  setEditingTab(tab.id);
  setEditValue(tab.label);
};

const saveEditTab = async (id) => {
  const updated = tabs.map((t) =>
    t.id === id ? { ...t, label: editValue } : t
  );

  setTabs(updated);
  setEditingTab(null);

  if (!space?.id) return;

  try {
    await updateDoc(doc(db, "spaces", space.id), {
      tabs: updated,
    });
  } catch (err) {
    console.error("Failed to save tab:", err);
  }
};

const deleteTab = async (id) => {
  const updated = tabs.filter((t) => t.id !== id);

  setTabs(updated);

  if (activeTab === id && updated.length) {
    setActiveTab(updated[0].id);
  }

  if (!space?.id) return;

  try {
    await updateDoc(doc(db, "spaces", space.id), {
      tabs: updated,
    });
  } catch (err) {
    console.error("Failed to delete tab:", err);
  }
};



    useEffect(() => {
  if (!space?.cover) {
    setCoverReady(true); // no image = instantly ready
    return;
  }

  setCoverReady(false);

  const img = new Image();
  img.src = space.cover;

  img.onload = () => setCoverReady(true);
  img.onerror = () => setCoverReady(true); // fallback safety
}, [space?.cover]);



    // ================= LOAD SPACE =================
useEffect(() => {
  const loadSpace = async () => {
    try {
      const q = query(
        collection(db, "spaces"),
        where("spaceLink", "==", spacelink)
      );

      const snap = await getDocs(q);

      if (snap.empty) {
        setStatus("notfound");
        return;
      }

      const docSnap = snap.docs[0];
      const docData = docSnap.data();

      setSpace({
        id: docSnap.id,
        ...docData,
      });

      setTabs(docData.tabs || [
  { id: "Space", label: "Space" },
  { id: "media", label: "Media" },
  { id: "about", label: "About" },
]);

      setCoverImages(docData.coverImages || []);

      setStatus("live");

      // ✅ FIX: only enable UI AFTER space is fully set
      setCoverReady(true);

    } catch (err) {
      console.error(err);
      setStatus("notfound");
    }
  };

  loadSpace();
}, [spacelink]);

  useEffect(() => {
    if (!coverImages.length) return;

    let loaded = 0;

    coverImages.forEach((src) => {
      const img = new Image();

      img.onload = () => {
        loaded++;
        if (loaded === coverImages.length) {
          setImagesReady(true);
        }
      };

      img.src = src;
    });
  }, [coverImages]);

  useEffect(() => {
    if (!imagesReady || coverImages.length <= 1) return;

    let timeout;

    const startLoop = () => {
      timeout = setTimeout(async () => {
        const nextIndex = (coverIndex + 1) % coverImages.length;
        const nextSrc = coverImages[nextIndex];

        // PRELOAD NEXT IMAGE (critical)
        await new Promise((resolve) => {
          const img = new Image();
          img.src = nextSrc;

          if (img.complete) return resolve();

          img.onload = resolve;
          img.onerror = resolve; // prevent freeze
        });

        // NOW SAFE TO SWITCH
        setPrevCover(coverImages[coverIndex]);
        setCoverIndex(nextIndex);
        setFade(true);

        // fast fade (NOT slow)
        requestAnimationFrame(() => {
          setFade(false);
        });

        startLoop();
      }, 3500);
    };

    startLoop();

    return () => clearTimeout(timeout);
  }, [imagesReady, coverImages, coverIndex]);


  // ================= POSTS =================
  const fetchPosts = async () => {
    const q = query(
      collection(db, "posts"),
      where("spacelink", "==", spacelink)
    );

    const snap = await getDocs(q);

    const allPosts = snap.docs
  .map(d => ({ id: d.id, ...d.data() }))
  .sort((a, b) => b.createdAt - a.createdAt);

  setPosts(allPosts);
  };

  useEffect(() => {
    fetchPosts();
  }, [user]);

  const handleAddPhoto = async (e) => {
    const file = e.target.files[0];
    if (!file || !user) return;

    try {
      const fileRef = ref(storage, `posts/${user.uid}/${Date.now()}_${file.name}`);
      await uploadBytes(fileRef, file);

      const url = await getDownloadURL(fileRef);

     await addDoc(collection(db, "posts"), {
        spacelink: spacelink,
        ownerUid: auth.currentUser.uid,
        type: "photo",
        content: url,
        tabId: activeTab,
        createdAt: Date.now()
      });

      e.target.value = null;
      fetchPosts();
    } catch (err) {
      console.error(err);
    }
  };

const handleBackgroundUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const fileRef = ref(storage, `spaces/main/${Date.now()}_${file.name}`);
    await uploadBytes(fileRef, file);

    const downloadURL = await getDownloadURL(fileRef);

    // 🔥 SAVE TO mainBg (NOT background)
    await updateDoc(doc(db, "spaces", space.id), {
      mainBg: downloadURL
    });

    // optional: refresh your state
    setSpace(prev => ({ ...prev, mainBg: downloadURL }));

  } catch (err) {
    console.error("Upload error:", err);
  }
};

const handleDeletePost = async (post) => {
  if (!window.confirm("Delete this post?")) return;

  try {
    // 🔥 delete image from storage (important)
    if (post.content) {
      const fileRef = ref(storage, post.content);
      await deleteObject(fileRef);
    }

    // 🔥 delete firestore doc
    await deleteDoc(doc(db, "posts", post.id));

    // 🔥 update UI instantly
    setPosts(prev => prev.filter(p => p.id !== post.id));

  } catch (err) {
    console.error("Delete failed:", err);
  }
};

const handleAddRSVP = async () => {
  if (!user) return;

  try {
    await addDoc(collection(db, "posts"), {
      spacelink,
      ownerUid: auth.currentUser.uid,
      type: "rsvp",

      title: "Will you celebrate with us?",
      description: "Please let us know if you can attend.",

      yesTitle: "We are excited to see you!",
      yesMessage: "Thank you for celebrating with us.",

      noTitle: "We understand",
      noMessage: "You may leave us a message.",

      tabId: activeTab,
      createdAt: Date.now()
    });

    fetchPosts();

  } catch (err) {
    console.error(err);
  }
};

const pad = (n) => String(n).padStart(2, "0");

const getTimeLeft = (targetDate) => {
  const diff = new Date(targetDate).getTime() - Date.now();

  if (diff <= 0) {
    return {
      done: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }

  return {
    done: false,
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const [tick, setTick] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setTick((t) => t + 1);
  }, 1000);

  return () => clearInterval(interval);
}, []);


    // ================= YOUTUBE =================
    const isYouTube =
      space?.music?.includes("youtube") ||
      space?.music?.includes("youtu.be");

    const getYouTubeId = (url) => {
      if (!url) return null;
      if (url.includes("watch?v=")) return url.split("v=")[1].split("&")[0];
      if (url.includes("youtu.be")) return url.split("/").pop();
      return null;
    };

    const videoId = getYouTubeId(space?.music);

    useEffect(() => {
      if (!isYouTube || !videoId) return;

      function createPlayer() {
        if (playerRef.current) return;

        playerRef.current = new window.YT.Player("yt-player", {
          height: "0",
          width: "0",
          videoId,
          playerVars: {
            autoplay: 0,
            controls: 0,
            loop: 1,
            playlist: videoId,
          },
        });
      }

      if (window.YT) {
        createPlayer();
      } else {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);

        window.onYouTubeIframeAPIReady = () => {
          setTimeout(createPlayer, 300);
        };
      }
    }, [videoId, isYouTube]);

    // ================= ENTER =================
    const handleEnter = () => {
      setEntered(true);

      if (
        isYouTube &&
        playerRef.current &&
        typeof playerRef.current.playVideo === "function"
      ) {
        playerRef.current.playVideo();
        setPlaying(true);
      }
    };

    const toggleMusic = () => {
      if (!playerRef.current) return;

      if (playing) {
        playerRef.current.pauseVideo();
        setPlaying(false);
      } else {
        playerRef.current.playVideo();
        setPlaying(true);
      }
    };

    // ================= STATES =================
  if (status === "loading" || !space) {
    return <div style={styles.center}>Loading...</div>;
  }

    if (status === "notfound") {
      return <div style={styles.center}>Space not found 🌿</div>;
    }

    const showCover = space?.cover;


return (
<div
ref={pageRef}
style={{
  ...styles.page,
background:
  space?.mainBg
    ? `url(${space.mainBg})`
    : "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
}}
>
      {isYouTube && <div id="yt-player" style={{ display: "none" }} />}

  {/* ================= ENTRY COVER ================= */}
        {!entered && (
          <div
            style={{
              ...styles.cover,
  backgroundColor:
    space?.bgMode === "color"
      ? space?.bgColor
      : "transparent",

  backgroundImage:
    space?.bgMode !== "color" && space?.cover
      ? `url(${space.cover})`
      : "none",

            }}
          >
  {/* OVERLAY */}
  {space?.overlay !== "none" && (
    <div
      style={{
        ...styles.overlay,
        background:
          space?.overlay === "light"
            ? "rgba(255,255,255,0.7)"
            : "rgba(0,0,0,0.7)"
      }}
    />
  )}

  {coverReady && (
  <button
    style={{
      ...styles.enterBtn,

      position: "absolute",   // ✅ REQUIRED

      left: "50%",

      // ✅ RESET FIRST (VERY IMPORTANT)
      top: "auto",
      bottom: "auto",
      transform: "translateX(-50%)",

      // ✅ APPLY POSITION
      ...(space?.buttonPosition === "top" && {
        top: "10%",
      }),

      ...(space?.buttonPosition === "center" && {
        top: "50%",
        transform: "translate(-50%, -50%)",
      }),

      ...(space?.buttonPosition === "bottom" && {
        bottom: "6.5%",
      }),

      // ✅ COLORS
      background: space?.buttonColor || "#000",
      color: space?.buttonTextColor || "#fff",
    }}
    onClick={handleEnter}
  >
    {space?.buttonText || "Enter"}
  </button>
    )}

          </div>
        )}


        {/* ================= MAIN ================= */}
      {(entered || !showCover) && (
        <div style={styles.card}>

{isOwner && (
  <button
    onClick={() => navigate(`/${spacelink}/rsvp`)}
    style={styles.rsvpBtn2}
  >
    RSVP List
  </button>
)}

{isOwner && (
  <button
    style={styles.customizeBtn}
    onClick={() => navigate(`/${spacelink}/customize`)}
  >
    Cst
  </button>
)}

{isOwner && (
  <div style={styles.editBtn}>
    <label style={{ cursor: "pointer", fontSize: "12px" }}>
      Edit

      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleBackgroundUpload}
      />
    </label>
  </div>
)}



            {/* COVER (SAFE) */}
            {space?.cover && (
              <div style={styles.coverBox}>
    
    {/* OLD IMAGE (fades out) */}
    {prevCover && (
      <div
        style={{
          ...styles.coverLayer,
          backgroundImage: `url(${prevCover})`,
          opacity: fade ? 0 : 1,
        }}
      />
    )}

    {/* NEW IMAGE (fades in) */}
    <div
      style={{
        ...styles.coverLayer,
        backgroundImage:
          coverImages.length > 0
            ? `url(${coverImages[coverIndex]})`
            : `url(${space.cover})`,
        opacity: fade ? 1 : 1,
      }}
    />

    <div style={styles.overlay} />

    {/* PENCIL stays here unchanged */}
    {isOwner && (
      <label style={styles.coverEditBtn}>
        Edit
        <input
          type="file"
          accept="image/*"
          multiple
          style={{ display: "none" }}
        onChange={async (e) => {
          const files = Array.from(e.target.files || []);
          if (!files.length || !space?.id) return;

          const uploadedUrls = [];

          for (const file of files) {
            const fileRef = ref(
              storage,
              `spaces/${space.id}/cover_${Date.now()}_${file.name}`
            );

            await uploadBytes(fileRef, file);
            const url = await getDownloadURL(fileRef);
            uploadedUrls.push(url);
          }

          const newList = [...coverImages, ...uploadedUrls];

          await updateDoc(doc(db, "spaces", space.id), {
            coverImages: newList,
          });

          setCoverImages(newList);
          setCoverIndex(0);
        }}
      />
    </label>
  )}
              </div>
            )}

            {/* TABS */}
<div style={styles.tabs}>
  
  {tabs.map((tab) => (
    <div key={tab.id} style={{ flex: 1, position: "relative" }}>

<div>
  {editingTab === tab.id ? (
    <>
      <input
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        style={{
          width: "100%",
          textAlign: "center",
          border: "none",
          outline: "none",
          padding: "10px",
        }}
      />

      <button onClick={() => saveEditTab(tab.id)}>Save</button>
      <button onClick={() => setEditingTab(null)}>Cancel</button>
    </>
  ) : (
    <button
      onClick={() => setActiveTab(tab.id)}
      style={activeTab === tab.id ? styles.activeTab : styles.tab}
    >
      {tab.label}
    </button>
  )}
</div>

      {/* EDIT ICON (only owner) */}
{isOwner && (
  <div style={{ position: "absolute", right: 5, top: 5 }}>
    <button
      onClick={() =>
        setOpenMenu(openMenu === tab.id ? null : tab.id)
      }
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
      }}
    >
      ⋮
    </button>

    {openMenu === tab.id && (
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 20,
          background: "#fff",
          border: "1px solid #ccc",
          borderRadius: "8px",
          zIndex: 999,
        }}
      >
        <button
          onClick={() => {
            setEditingTab(tab.id);
            setEditValue(tab.label);
            setOpenMenu(null);
          }}
        >
          Edit
        </button>

        <button onClick={() => deleteTab(tab.id)}>
          Delete
        </button>
      </div>
    )}
  </div>
)}
    </div>
  ))}

{isOwner && tabs.length < 5 && (
  <button
    onClick={addTab}
    style={{
      padding: "12px",
      background: "none",
      border: "none",
      cursor: "pointer",
      fontSize: "18px",
    }}
  >
    +
  </button>
)}

</div>

          

{/* ================= TAB CONTENT ================= */}
          <div style={styles.content}>

  <div>
    {/* Upload */}
    <div style={styles.fabContainer}>
{isOwner && (
  <label style={styles.fabBtn}>
    Image
    <input
      type="file"
      accept="image/*"
      style={{ display: "none" }}
      onChange={handleAddPhoto}
    />
  </label>
)}

{isOwner && (
  <button style={styles.fabBtn} onClick={handleAddRSVP}>
    RSVP
  </button>
)}

{isOwner && (
  <button
    style={styles.fabBtn}
    onClick={() => setShowCountdownModal(true)}
  >
    Cntdwn
  </button>
)}
    </div>

    {/* Posts */}
    {posts.length === 0 ? (
      <p>No posts yet 🌿</p>
    ) : (
      posts
  .filter(post => post.tabId === activeTab)
  .map(post => (
  <div key={post.id} style={styles.postCard}>

    {isOwner && (
      <button
        style={styles.deleteBtn}
        onClick={() => handleDeletePost(post)}
      >
        🗑
      </button>
    )}
          {post.type === "photo" && (
            <img src={post.content} style={styles.postImage} />
          )}

{post.type === "rsvp" && (
  <button
    style={styles.rsvpPost}
    onClick={() => setSelectedRsvp(post)}
  >
    RSVP
  </button>
)}

{post.type === "countdown" && (() => {
  const t = getTimeLeft(post.targetDate);

  return (
<div style={styles.countdownPost}>
  <h3 style={{ marginBottom: "10px" }}>
  {post.title || "Countdown"}
</h3>

  <div style={styles.timerRow}>

    <div style={styles.item}>
      <div style={styles.timeBox}>{pad(t.days)}</div>
      <div style={styles.label}>Days</div>
    </div>

    <div style={styles.colon}>:</div>

    <div style={styles.item}>
      <div style={styles.timeBox}>{pad(t.hours)}</div>
      <div style={styles.label}>Hours</div>
    </div>

    <div style={styles.colon}>:</div>

    <div style={styles.item}>
      <div style={styles.timeBox}>{pad(t.minutes)}</div>
      <div style={styles.label}>Minutes</div>
    </div>

    <div style={styles.colon}>:</div>

    <div style={styles.item}>
      <div style={styles.timeBox}>{pad(t.seconds)}</div>
      <div style={styles.label}>Seconds</div>
    </div>

  </div>

</div>
  );
})()}

          </div>
        ))
    )}

                  {/* MUSIC */}
          {isYouTube && (
            <div style={styles.player}>
<button
  onClick={toggleMusic}
  style={{
    padding: "12px 24px",
    borderRadius: "999px",
    border: "none",
    background: "rgba(255,255,255,0.25)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    color: "#000",
    fontFamily: "Playfair Display, serif",
    fontSize: "15px",
    letterSpacing: "1px",
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  }}
>
  {playing ? "Pause ❚❚ " : "Play ▶︎ "}
</button>
            </div>
          )}
  </div>

          {/* MEDIA TAB */}
{activeTab === "media" && (
  <div style={styles.photoGrid}>
    {posts.length === 0 ? (
      <p>No media yet 🌿</p>
    ) : (
      posts.map(post => (
        <img
          key={post.id}
          src={post.content}
          style={styles.photo}
        />
      ))
    )}

              {/* MUSIC */}
          {isYouTube && (
            <div style={styles.player}>
              <button onClick={toggleMusic}>
                {playing ? "Pause ⏸" : "Play ▶"}
              </button>
            </div>
          )}
  </div>
)}

          {/* ABOUT TAB */}
          {activeTab === "about" && (
            <div>
              <h2>{space?.spaceName}</h2>
            </div>
          )}
        </div>
      </div>
    )}

{selectedRsvp && (
  <div
    style={styles.modalOverlay}
onClick={() => resetRSVP()}
  >
    <div
      style={styles.modalBox}
      onClick={(e) => e.stopPropagation()}
      
    >


<button
onClick={() => {
  resetRSVP();
}}
  style={{
    position: "absolute",
    top: "12px",
    right: "8px",
    background: "none",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    fontWeight: "300",
    lineHeight: "1",
    color: "#000"
  }}
>
  ×
</button>

{/* ================= EDIT MODE ================= */}
{isEditingRsvp ? (
  <>
    <h3>Edit RSVP</h3>

    <input
      type="text"
      placeholder="RSVP Title"
      value={selectedRsvp.title || ""}
      onChange={(e) =>
        setSelectedRsvp({
          ...selectedRsvp,
          title: e.target.value
        })
      }
      style={styles.input}
    />

    <textarea
      placeholder="RSVP Description"
      value={selectedRsvp.description || ""}
      onChange={(e) =>
        setSelectedRsvp({
          ...selectedRsvp,
          description: e.target.value
        })
      }
      style={styles.textarea}
    />

    <input
      type="text"
      placeholder="YES response has been submitted"
      value={selectedRsvp.yesTitle || ""}
      onChange={(e) =>
        setSelectedRsvp({
          ...selectedRsvp,
          yesTitle: e.target.value
        })
      }
      style={styles.input}
    />

    <textarea
      placeholder="Message for a YES response"
      value={selectedRsvp.yesMessage || ""}
      onChange={(e) =>
        setSelectedRsvp({
          ...selectedRsvp,
          yesMessage: e.target.value
        })
      }
      style={styles.textarea}
    />

    <input
      type="text"
      placeholder="NO response has been submitted"
      value={selectedRsvp.noTitle || ""}
      onChange={(e) =>
        setSelectedRsvp({
          ...selectedRsvp,
          noTitle: e.target.value
        })
      }
      style={styles.input}
    />

    <textarea
      placeholder="Message for a NO response"
      value={selectedRsvp.noMessage || ""}
      onChange={(e) =>
        setSelectedRsvp({
          ...selectedRsvp,
          noMessage: e.target.value
        })
      }
      style={styles.textarea}
    />

    <button
      onClick={async () => {
        await updateDoc(doc(db, "posts", selectedRsvp.id), {
          title: selectedRsvp.title || "",
          description: selectedRsvp.description || "",
          yesTitle: selectedRsvp.yesTitle || "",
          yesMessage: selectedRsvp.yesMessage || "",
          noTitle: selectedRsvp.noTitle || "",
          noMessage: selectedRsvp.noMessage || "",
        });

        setIsEditingRsvp(false);
        fetchPosts();
      }}
    >
      Save
    </button>
  </>
) : (
  <>
    {/* ================= NORMAL VIEW ================= */}

<h2
  style={{
    fontFamily: "Playfair Display, serif",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "10px",
    letterSpacing: "1px",
    color: "#000"
  }}
>
  {selectedRsvp.title || "RSVP"}
</h2>

<p
  style={{
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    lineHeight: "1.6",
    letterSpacing: ".5px",
    opacity: 0.8,
    marginBottom: "10px",
    color: "#000"
  }}
>
  {selectedRsvp.description ||
    "Please let us know if you can attend."}
</p>

    {/* FULL NAMES */}
    {guestNames.map((name, index) => (
      <input
        key={index}
        type="text"
        placeholder={
  index === 0
    ? "Name or Nickname"
    : `Additional Guest (Full Name) ${index}`
}
        value={name}
        onChange={(e) => {
          const updated = [...guestNames];
          updated[index] = e.target.value;
          setGuestNames(updated);
        }}
        style={styles.input}
      />
    ))}

    {/* PLUS ONE */}
    {guestNames.length < 4 && (
<button
  style={{
    marginBottom: "15px",
    padding: "12px 18px",
    borderRadius: "999px",
    border: "none",
    background: "#e8e8e8",
    color: "#000",
    cursor: "pointer",
    fontFamily: "Playfair Display, serif",
    fontWeight: "500",
    fontSize: "14px",
  }}
  onClick={() =>
    setGuestNames([...guestNames, ""])
  }
>
  Add Guest
</button>
    )}

    {/* YES / NO */}
    {!rsvpAnswer && (
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
        }}
      >
<button
  style={{
    flex: 1,
    padding: "14px",
    borderRadius: "999px",
    border: "none",
    background: "#000",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "300",
    cursor: "pointer",
    fontFamily: "Playfair Display, serif",
  }}
onClick={async () => {
  setRsvpAnswer("yes");

  await addDoc(collection(db, "rsvps"), {
    spacelink,
    names: guestNames,
    response: "yes",
    message: "", // optional later
    createdAt: Date.now(),
  });
}}
>
  Yes
</button>

<button
  style={{
    flex: 1,
    padding: "14px",
    borderRadius: "999px",
    border: "none",
    background: "#e8e8e8",
    color: "#000",
    fontSize: "15px",
    fontWeight: "300",
    cursor: "pointer",
    fontFamily: "Playfair Display, serif",
  }}
 onClick={async () => {
  setRsvpAnswer("no");
  await addDoc(collection(db, "rsvps"), {
    spacelink,
    names: guestNames,
    response: "no",
    message: "", // optional later
    createdAt: Date.now(),
  });
}}
>
  No
</button>
      </div>
    )}

    {/* YES RESPONSE */}
    {rsvpAnswer === "yes" && (
      <div style={{ marginTop: "0px" }}>

<h3
  style={{
    fontFamily: "Poppins, sans-serif",
    fontSize: "12px",
    fontWeight: "300",
    marginBottom: "10px",
    color: "#000"
  }}
>
  {selectedRsvp.yesTitle || "Your response has been submitted!"}
</h3>

    <p
      style={{
        fontFamily: "Playfair Display, serif",
        fontSize: "15px",
        opacity: 0.8,
        marginBottom: "10px",
        color: "#000"
      }}
    >
      {selectedRsvp.yesMessage || "Thank you. See you!"}
    </p>



    {/* optional message only */}
    <textarea
      placeholder="Leave a message (optional)"
      value={guestMessage}
      onChange={(e) => setGuestMessage(e.target.value)}
      style={styles.textarea}
    />

    <button
    style={{
    flex: 1,
    padding: "12px 18px",
    borderRadius: "999px",
    border: "none",
    background: "#000",
    color: "#ffffff",
    fontSize: "15px",
    fontWeight: "300",
    cursor: "pointer",
    fontFamily: "Playfair Display, serif",
  }}
      onClick={async () => {
        await addDoc(collection(db, "rsvps"), {
          spacelink,
          names: guestNames,
          response: "yes",
          message: guestMessage,
          createdAt: Date.now(),
        });

resetRSVP();
fetchPosts();
      }}
    >
      Send Message
    </button>

  </div>
)}

{/* NO RESPONSE */}
{rsvpAnswer === "no" && (
  <div style={{ marginTop: "0px" }}>

    {/* TITLE */}
    <h3
      style={{
        fontFamily: "Poppins, sans-serif",
        fontSize: "12px",
        fontWeight: "300",
        marginBottom: "10px",
        color: "#000",
      }}
    >
      {selectedRsvp.noTitle || "Your response has been submitted"}
    </h3>

    {/* MESSAGE */}
    <p
      style={{
        fontFamily: "Playfair Display, serif",
        fontSize: "15px",
        opacity: 0.8,
        marginBottom: "10px",
        color: "#000",
      }}
    >
      {selectedRsvp.noMessage ||
        "Thank you for your response. Feel free to leave a message."}
    </p>

    {/* OPTIONAL MESSAGE INPUT */}
    <textarea
      placeholder="Leave a message (optional)"
      value={guestMessage}
      onChange={(e) => setGuestMessage(e.target.value)}
      style={styles.textarea}
    />

    {/* SUBMIT BUTTON */}
    <button
      style={{
        flex: 1,
        padding: "12px 18px",
        borderRadius: "999px",
        border: "none",
        background: "#000",
        color: "#fff",
        fontSize: "15px",
        fontWeight: "300",
        cursor: "pointer",
        fontFamily: "Playfair Display, serif",
        marginTop: "10px",
      }}
onClick={async () => {
  try {
    await addDoc(collection(db, "rsvps"), {
      spacelink,
      names: guestNames,
      response: "no",
      message: guestMessage, // ALWAYS save even if empty
      createdAt: Date.now(),
    });

    // reset AFTER save
resetRSVP();
fetchPosts();

    fetchPosts();
  } catch (err) {
    console.error("RSVP save failed:", err);
  }
}}
    >
      Send Message
    </button>

  </div>
)}


    {/* OWNER EDIT BUTTON */}
    {isOwner && (
<button
  onClick={() => setIsEditingRsvp(true)}
  style={{
    marginTop: "15px",
    width: "50%",
    padding: "12px 18px",
    borderRadius: "999px",
    border: "none",
    background: "#e8e8e8",
    color: "#000",
    cursor: "pointer",
    fontFamily: "Playfair Display, serif",
    fontWeight: "300",
    fontSize: "14px",
  }}
>
  Edit RSVP
</button>
    )}
  </>
)}

    </div>
  </div>
)}


  {showCountdownModal && (
    <div style={styles.modalOverlay} onClick={() => setShowCountdownModal(false)}>
      <div style={styles.modalBox} onClick={(e) => e.stopPropagation()}>

        <h3>Create Countdown</h3>

        {/* TITLE INPUT */}
        <input
          type="text"
          placeholder="Countdown title..."
          value={countdownTitle}
          onChange={(e) => setCountdownTitle(e.target.value)}
          style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
        />

        {/* DATE INPUT */}
        <input
          type="datetime-local"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
        />

        <button
          onClick={async () => {
            if (!selectedDate) return;

            await addDoc(collection(db, "posts"), {
              spacelink,
              ownerUid: auth.currentUser.uid,
              type: "countdown",
              title: countdownTitle,   // ✅ ADD THIS
              tabId: activeTab,
              targetDate: selectedDate,
              createdAt: Date.now()
            });

            setShowCountdownModal(false);
            setSelectedDate("");
            setCountdownTitle(""); // reset
            fetchPosts();
          }}
        >
          Add Countdown
        </button>

        <button onClick={() => setShowCountdownModal(false)}>
          Cancel
        </button>

      </div>
    </div>
  )}


    </div>
  );
  }
  export default Space;

  const styles = {
    center: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },

    page: {
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      overflowY: "auto"
    },

  card: {
    width: "100%",
    maxWidth: "800px",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(255, 255, 255, 0.4)"
  },

    cover: {
      position: "fixed",
      inset: 0,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },

    coverBox: {
      height: "200px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: "sticky",
      top: 0,               // ✅ stick to top
      zIndex: 5,
      transition: "background-image 1s ease-in-out",
    },

    overlay: {
      position: "absolute",
      inset: 0,
      opacity: 0.4
    },

    coverContent: {
      position: "relative",
      zIndex: 2,
      padding: "15px",
      color: "#000000"
    },

    enterBtn: {
      position: "absolute",
      bottom: "6.5%",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 2,
      padding: "15px 30px",
      borderRadius: "30px",
      border: "none",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },

tabs: {
  display: "flex",
  position: "sticky",
  top: 200,
  backgroundColor: "rgba(255,255,255,0.4)", // match card feel
  backdropFilter: "blur(10px)",              // glass effect (optional but nice)
  WebkitBackdropFilter: "blur(10px)",
  zIndex: 9999,
  textAlign: "center",
},

    tab: {
      flex: 1,
      padding: "12px",
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "#333",
      whiteSpace: "nowrap",
    },

    activeTab: {
      flex: 1,
      padding: "12px",
      fontWeight: "bold",
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "#000"
    },
player: {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "50px",
  marginBottom: "100px",
},

    content: {
      flex: 1,
      position: "relative",
      zIndex: 1,
    },

  photoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // 👈 always 3 columns
    gap: "0px",
    paddingBottom: "20px",
  },

  photo: {
    width: "100%",
    height: "120px",
    objectFit: "cover",
    borderRadius: "0px",
    display: "block",
  },

  previewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "8px",
    marginTop: "10px",
  },

  postCard: {
    width: "100%",
    position: "relative",
  },

  postImage: {
    width: "100%",
    aspectRatio: "2 / 3",
    objectFit: "cover",
    display: "block",
  },

  editBtn: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    background: "#000",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: 999,
  },

  coverEditBtn: {
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "rgba(0,0,0,0.6)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 10,
    fontSize: "12px",
  },

  coverLayer: {
    position: "absolute",
    inset: 0,
    backgroundSize: "cover",
    backgroundPosition: "center",
    transition: "opacity 0.2s ease-out"
  },

  deleteBtn: {
    position: "absolute",
    top: "8px",
    right: "8px",
    background: "rgba(0,0,0,0.6)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    cursor: "pointer",
    zIndex: 10,
  },

  fabContainer: {
    position: "fixed",
    bottom: "140px",
    right: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    zIndex: 999,
    alignItems: "flex-end",
  },

  fabBtn: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    background: "#000",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    border: "none",
    cursor: "pointer",
  },

  customizeBtn: {
    position: "fixed",
    bottom: "80px", // 👈 above upload (80px)
    right: "20px",
    height: "45px",
    padding: "0 14px",
    borderRadius: "25px",
    background: "#000",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    cursor: "pointer",
    zIndex: 999,
    border: "none",
  },

  rsvpBtn: {
    marginTop: "10px",
    background: "#000",
    color: "#f6e2e2",
    border: "none",
    borderRadius: "20px",
    padding: "8px 12px",
    cursor: "pointer",
  },

rsvpBtn2: {
  position: "fixed",
  bottom: "320px", // ABOVE customize
  right: "20px",
  height: "45px",
  padding: "8 12px",
  borderRadius: "20px",
  background: "#000",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "12px",
  cursor: "pointer",
  zIndex: 999,
  border: "none",
},

  rsvpPost: {
    width: "150px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#000",
    color: "#fff",
    border: "none",
    borderRadius: "999px",
    cursor: "pointer",
    fontWeight: "600",
    marginTop: "40px",   // 👈 control top only
    marginBottom: "50px", // 👈 keep bottom space
    fontSize: "20px", 
    marginLeft: "auto",
    marginRight: "auto",
  },

modalOverlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  padding: "20px", // ✅ IMPORTANT for small screens
},

modalBox: {
  width: "255px",
  maxHeight: "80vh",        // ✅ limits height
  overflowY: "auto",
  scrollBehavior: "smooth",        // ✅ enables scrolling
  background: "#fff",
  padding: "20px",
  borderRadius: "12px",
  textAlign: "center",
  position: "relative",
},

  countdownBtn: {
    marginTop: "10px",
    background: "#111",
    color: "#fff",
    border: "none",
    borderRadius: "20px",
    padding: "8px 12px",
    cursor: "pointer",
  },

  countdownPost: {
    width: "100%",
    margin: "40px 0 40px",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    textAlign: "center",
    fontWeight: "200",
    borderRadius: "15px",
    fontFamily: "Playfair Display, serif",
    color: "#000000",
    letterSpacing: "1px"
  },

  timerRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "10px",
    fontFamily: "Playfair Display, serif",
  },

  unit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  timeBox: {
    fontSize: "50px",   // increased
    fontWeight: "800",
    minWidth: "60px",
    textAlign: "center",
    color: "#000",
  },

  label: {
    fontSize: "20px",   // increased slightly
    marginTop: "6px",
    letterSpacing: "1px",
    color: "#000",
    fontFamily: "Playfair Display, serif",
  },

  colon: {
    fontSize: "30px",
    fontWeight: "700",
    lineHeight: "60px", // 👈 THIS fixes alignment
    display: "flex",
    alignItems: "center",
  },

input: {
  width: "100%",
  padding: "12px",
  marginBottom: "15px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  fontSize: "14px",
  boxSizing: "border-box",
  fontFamily: "Playfair Display, serif",
},

textarea: {
  width: "100%",
  minHeight: "100px",
  padding: "12px",
  marginTop: "10px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  fontSize: "14px",
  resize: "none",
  boxSizing: "border-box",
  fontFamily: "Playfair Display, serif",
},

  };